/** @jsxImportSource @emotion/react */
import { FC } from "react";
import { Row } from "react-grid-system";
import Column from "../../../../../../components/Grid/Column";
import Many2ManyInput from "../../../../../../components/Input/SelectInputs/Many2ManyInput";
import MultiSelectInput from "../../../../../../components/Input/SelectInputs/MultiSelectInput";
import Typography from "../../../../../../components/Typography";
import { TModelFilter } from "../../../../../../hooks/useModelFilter";

const marginBottom = 24;
const horizontalLineHeight = 2;
const filterHeight = 110;

export const totalFilterHeight =
  filterHeight + marginBottom + horizontalLineHeight * 2;
interface FiltersProps {
  filter: TModelFilter;
}

const Filters: FC<FiltersProps> = ({ filter }) => {
  const { filters, setFilterValue } = filter;

  return (
    <div
      css={{
        marginBottom: marginBottom,
        zIndex: 100,
        position: "relative",
      }}
    >
      <Row css={{ margin: 0, height: filterHeight }} justify="center">
        <Column>
          <Row css={{ margin: 0, height: "100%" }} align="center">
            {filters.map((filter) => (
              <Column xs={12} key={filter.name}>
                <Row
                  css={{ margin: 0, height: "100%", marginBottom: 15 }}
                  align="center"
                >
                  <Column xs={12} css={{ marginBottom: 10 }}>
                    <Typography
                      variant="textMedium"
                      color="Black"
                      uppercase
                      weight="bold"
                      component="div"
                      align="left"
                    >
                      {filter.label}
                    </Typography>
                  </Column>
                  <Column>
                    {!filter.many2Many && (
                      <MultiSelectInput
                        options={filter.options}
                        inputName={filter.name}
                        onSelect={(value) => setFilterValue(filter.name, value)}
                        value={filter.value}
                        hideDropdown
                        multiValueDisplay={filter.selectMultiValueDisplay}
                        optionDisplay={filter.selectOptionDisplay}
                        placeholder="Todos"
                      />
                    )}
                    {filter.many2Many && (
                      <Many2ManyInput
                        serviceName={filter.many2Many?.serviceName}
                        domain={filter.many2Many?.domain}
                        inputName={filter.name}
                        onSelect={(value) => setFilterValue(filter.name, value)}
                        value={filter.value}
                        hideDropdown
                        multiValueDisplay={filter.selectMultiValueDisplay}
                        optionDisplay={filter.selectOptionDisplay}
                        placeholder="Todos"
                      />
                    )}
                  </Column>
                </Row>
              </Column>
            ))}
          </Row>
        </Column>
      </Row>
    </div>
  );
};

export default Filters;
